import { Theme } from "../core/Theme";

/**
 * @ignore
 */
export class KshowTheme extends Theme {
	protected setupDefaultRules() {
		super.setupDefaultRules();
        const isInViewport = function(el:HTMLElement) {
            const rec = el.getBoundingClientRect();
            return (
                rec.top >= 0 &&
                rec.left >= 0 &&
                rec.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rec.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };

        this.rule("Series").setup = function(target){
            function chartInView() {
                if (isInViewport(target.root.dom)) { 
                  target.get('visible')?null:target.appear(1000, 100);
                }
            }            
            window.addEventListener("DOMContentLoaded", () => { chartInView(); });
            window.addEventListener("load", () => { chartInView(); });
            window.addEventListener("risize", () => { chartInView(); });   
            window.addEventListener("scroll", () => { chartInView(); });  
        };

		this.rule("Series").setAll({
            sequencedInterpolation: true,
            sequencedDelay: 30
		});
	}
}